// Title-bar slot on the web arm only (sdk ADR-017). Download stays
// visible; the desktop-status pill is the open control.
import { DesktopHandoffOffer } from './DesktopHandoffOffer';

export function WebDesktopHandoff() {
  return <DesktopHandoffOffer />;
}
